import BoardsList from "./BoardsList.jsx";

export default BoardsList;
